import React from 'react';

import CloseIcon from '../components/Icons/Close';
import CheckIcon from '../components/Icons/Check';

import { CardsProps } from '../types';

import {
  CardContainer,
  Header,
  Activity,
  TimeInfo,
  ButtonContainer,
  Button,
  Icon,
  Infos,
} from './styles';

export const Pending: React.FC<CardsProps> = ({
  name,
  activity,
  date,
  time,
  hasSelfCheckin,
  onAccept,
  onReject,
  ref,
  openCheckinDetailModal,
}) => {
  const showCheckinDetail = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    const target = event.target as HTMLElement;
    if (target.closest('button') || !openCheckinDetailModal) return;

    openCheckinDetailModal();
  };

  return (
    <CardContainer ref={ref} onClick={showCheckinDetail}>
      <Header className="userName">{name}</Header>
      <Infos>
        <Activity>{activity}</Activity>
        <div className="dot">•</div>
        <TimeInfo>{`${date} • ${time}`}</TimeInfo>
      </Infos>
      <ButtonContainer>
        {onAccept && !hasSelfCheckin && (
          <Button isAccept onClick={onAccept}>
            Fazer check-in{' '}
            <Icon>
              <CheckIcon />
            </Icon>
          </Button>
        )}
        {onReject && (
          <Button onClick={onReject}>
            Cancelar agendamento{' '}
            <Icon>
              <CloseIcon />
            </Icon>
          </Button>
        )}
      </ButtonContainer>
    </CardContainer>
  );
};

export default Pending;
